import { useSnackbarContext } from "../context/SnackbarProvider";

// useSnackbar hook to trigger global MUI Snackbar from any component.
// Usage: const showSnackbar = useSnackbar();
//        showSnackbar({ message: 'Hello', type: 'info' });

export const useSnackbar = () => {
  const { showSnackbar } = useSnackbarContext();
  return showSnackbar;
};
